export default __webpack_public_path__ + "static/media/HindMadurai.3b351ad4.ttf";